// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TYCn","content":"styles_content__3RFuf"};